export default __webpack_public_path__ + "d71a85998736714db93433188cc95522.png";